import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react'
import { CityDropdownForTrip, CommonCheckbox, CommonInput, CommonTextarea, CrossButton, CustomSelect } from 'components'
import { errorSchema, utils } from 'helper';
import { City, State } from "country-state-city";
import StorageService from "utils/StorageServices/StorageServices";
import { UserContext } from "context";
import toast, { Toaster } from 'react-hot-toast';
import { AddButton } from 'components/common/CommonButton';
import { createBranch, updateBranch, getBranch } from '_services/accountsServices/branchServices';
import { constant } from 'constants/constant';
import { getStatesData, handleKeyDown } from '_services';
import { getCityLocationList } from '_services/accountsServices/cityLocationService';
import AddLocationModal from 'modals/AddLocationModal';
import { getFirm, getUserFirm } from '_services/accountsServices/firmServices';
import FirmImg from '../../assets/img/firm.png';
import { Link } from 'react-router-dom';
import { FaYoutube } from 'react-icons/fa6';
import YoutubeModal from 'modals/YoutubeModal';
import GstDetailModal from 'modals/GstDetailModal';
import { globleGstInformation } from '_services/accountsServices/consignorServices';

const supplier_freight = {
    view: 1,
    mandatory: 1
}

const formObj = {
    company_id: StorageService.getCompanyId(),
    branch: '',
    display_name: '',
    contact_no: '',
    branch_code: '',
    address_line1: '',
    fssai_licence: '',
    terms_conditions: '',
    state: {},
    city: {},
    pincode: '',
    email_id: '',
    alt_contact_no: '',
    gst_treatment_id: {},
    gst_no: '',
    gst_state: {},
    remarks: '',
    lr_bilty_format: '',
    firm_id: {},
}

const newFormObj = {
    lr_bilty_format: '',
}


const AddEditBranch = (props) => {
    let { isOpen, onClose, isPreviousModal, isEwayBillTrue = false, showingPrefield, hideAddNewOption = true, firmId = {} } = props;

    const { masterData, cities, states, setStates, userData, youtubeVideos, setYoutubeVideos } = useContext(UserContext);

    const [formValue, setFormValue] = useState(formObj);
    const [formError, setFormError] = useState({});
    const [loading, setLoading] = useState(false);
    const [stateValue, setStateValue] = useState({});
    const [activeTab, setActiveTab] = useState(1);
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);
    const [supplierFreight, setSupplierFreigt] = useState(supplier_freight)
    const [builtyFormat, setBuiltyFormat] = useState(newFormObj)
    const [openLoction, setOpenLoction] = useState(false);

    const [firmDataList, setFirmDataList] = useState([]);

    const [showSelectListModal, setShowSelectListModal] = useState(false);
    const [isActionCreate, setIsActionCreate] = useState(true);
    const [gstInformationLoading, setGstInformationLoading] = useState(false);

    useEffect(() => {
        if (!builtyFormat.lr_bilty_format) {
            if (masterData?.lr_bilty_format_list?.length) {
                const firstItem = {
                    label: masterData.lr_bilty_format_list[0]?.name,
                    value: masterData.lr_bilty_format_list[0]?.id,
                };
                setBuiltyFormat((prevState) => ({
                    ...prevState,
                    lr_bilty_format: firstItem,
                }));
            }
        }
    }, [masterData]);

    useEffect(() => {
        if (!isOpen?._id) {
            // if (masterData?.gst_type_list?.length > 0 && states?.length > 0) {
            setFormValue((s) => ({
                ...s,
                gst_state: formValue?.state?.label ? {
                    label: formValue?.state?.label ? formValue?.state?.label : '',
                    value: formValue?.state?.value ? formValue?.state?.value : '',
                } : {},
                gst_treatment_id: isActionCreate ? (masterData?.gst_type_list?.length > 0 ? masterData?.gst_type_list?.map((el) => {
                    return {
                        label: el?.name,
                        value: el?.id
                    }
                })[0] : { value: 1, label: "Unregistered Business" }) : masterData?.gst_type_list?.map((el) => {
                    return {
                        label: el?.name,
                        value: el?.id
                    }
                })[1],
                // gst_treatment_id: masterData?.gst_type_list.map((el) => ({
                //     label: el?.name,
                //     value: el?.id,
                // }))[0],
                company_id: StorageService.getCompanyId(),
            }));
            // }
        }
    }, [masterData, StorageService.getCompanyId, isOpen, formValue?.state]); // states

    useEffect(() => {
        setFormValue((prev) => ({
            ...prev,
            lr_bilty_format: builtyFormat?.lr_bilty_format?.value
        }))
    }, [builtyFormat.lr_bilty_format])

    const onhandleSelectBuilty = async (item, name) => {
        const stateObj = { ...builtyFormat, [name]: item };
        setBuiltyFormat(stateObj);

        if (!utils.isObjectKeyEmpty(formError)) {
            const validationResult = await utils.checkFormError(stateObj, errorSchema.createBranch);
            setFormError(validationResult === true ? "" : validationResult);
        }
    };

    const fetchFromCity = async (search, page, limit) => {
        const res = await getCityLocationList({
            countryCode: "IN",
            stateCode: "",
            offset: page,
            limit,
            search,

        });
        if (res?.responseCode === 200) {
            const list = res?.data?.all_cities.map((c) => ({ ...c, value: c.name, label: c.name }))

            return {

                items: [...list],

                total: res?.data?.total_record,
            };

        } else {
            toast.error(res?.responseMessage);
        }
    };

    // const findSingleBranchData = async (_id) => {
    //     const object = {
    //         company_id: StorageService.getCompanyId(),
    //         branch_id: _id
    //     }
    //     try {
    //         const res = await getBranch(object);
    //         if (res?.responseCode == 200) {

    //             let newObj = { ...res?.data?.branch };
    //             if (newObj?.gst_state === null) {
    //                 newObj.gst_state = newObj?.gst_state?.label ? newObj?.gst_state : {}
    //             }
    //             if (newObj?.gst_treatment_id === null) {
    //                 newObj.gst_treatment_id = masterData?.gst_type_list.map((el) => ({
    //                     label: el?.name,
    //                     value: el?.id,
    //                 }))[0]
    //             } else {
    //                 if (newObj?.gst_type > 0) {
    //                     let object = masterData?.gst_type_list.find((el) => el?.id === res?.data?.branch?.gst_type);
    //                     newObj.gst_treatment_id = { label: object?.name, value: object?.id, }
    //                 }
    //             }

    //             setFormValue((s) => ({ ...s, ...newObj }));
    //             setSupplierFreigt(res?.data?.branch?.permission_at_supplier?.supplier_freight)

    //         }
    //     } catch (error) {
    //         toast.error('Error fetching Branch Data');
    //     }
    // }

    const findSingleBranchData = async (_id) => {
        const object = {
            company_id: StorageService.getCompanyId(),
            branch_id: _id
        };
        try {
            const res = await getBranch(object);
            if (res?.responseCode == 200) {

                const branch = res?.data?.branch;

                // Resolve gst_treatment_id logic
                let gst_treatment_id = {};
                if (isOpen?._id && branch?.gst_type === null) {
                    gst_treatment_id = masterData?.gst_type_list.map((el) => ({
                        label: el?.name,
                        value: el?.id,
                    }))[0]
                }
                if (branch?.gst_treatment_id === null) {
                    gst_treatment_id = masterData?.gst_type_list.map((el) => ({
                        label: el?.name,
                        value: el?.id,
                    }))[0];
                } else if (branch?.gst_type > 0) {
                    let object = masterData?.gst_type_list.find((el) => el?.id === branch?.gst_type);
                    gst_treatment_id = { label: object?.name, value: object?.id };
                }

                const newFormValue = {
                    company_id: StorageService.getCompanyId(),
                    // firm_id: branch?.firm_id ? branch?.firm_id : '',
                    firm_id: {
                        label: branch?.firm_id?.firm,
                        value: branch?.firm_id?._id,
                    },
                    branch: branch?.branch || '',
                    display_name: branch?.display_name || '',
                    contact_no: branch?.contact_no || '',
                    branch_code: branch?.branch_code || '',
                    address_line1: branch?.address_line1 || '',
                    fssai_licence: branch?.fssai_licence || '',
                    terms_conditions: branch?.terms_conditions || '',
                    state: branch?.state || {},
                    city: branch?.city || {},
                    pincode: branch?.pincode || '',
                    email_id: branch?.email_id || '',
                    alt_contact_no: branch?.alt_contact_no || '',
                    gst_treatment_id: gst_treatment_id || {},
                    gst_no: branch?.gst_no || '',
                    gst_state: branch?.gst_state || {},
                    remarks: branch?.remarks || '',
                    lr_bilty_format: branch?.lr_bilty_format || '',
                };

                setFormValue(newFormValue);

                setSupplierFreigt(branch?.permission_at_supplier?.supplier_freight);
            }
        } catch (error) {
            toast.error('Error fetching Branch Data');
        }
    };

    useEffect(() => {
        if (isOpen?._id && formValue.lr_bilty_format) {
            const biltyObject = masterData?.lr_bilty_format_list?.find(item => item.id === formValue.lr_bilty_format)
            setBuiltyFormat((prev) => ({
                ...prev,
                lr_bilty_format: {
                    value: biltyObject.id,
                    label: biltyObject.name
                }
            }))
        }
    }, [formValue.lr_bilty_format, isOpen?._id])

    useEffect(() => {
        if (isOpen?._id) {
            findSingleBranchData(isOpen?._id)
        }
    }, [isOpen])

    const handleOnChange = async (name, value) => {
        const stateObj = { ...formValue, [name]: value };
        if (name === "gst_no") {
            let gstCode = parseInt(value.slice(0, 2), 10);
            stateObj['gst_state'] = utils.codeToStateNameObject[gstCode];
        }
        // if (name === 'branch') {
        //     stateObj['display_name'] = value;
        // }
        setFormValue(stateObj);

        if (!utils.isObjectKeyEmpty(formError)) {
            const validationResult = await utils.checkFormError(stateObj, errorSchema.createBranch);
            setFormError(validationResult === true ? "" : validationResult);
        }
    };

    const handleOnChangeCheck = async (name, value) => {

        const stateObj = { ...supplierFreight, [name]: value };

        const update = { ...stateObj }
        if (name == "view") {
            if (value == 0) {
                update.mandatory = 0
            }
        }
        setSupplierFreigt(update);

        // if (!utils.isObjectKeyEmpty(formError)) {
        //     const validationResult = await utils.checkFormError(stateObj, errorSchema.createBranch);
        //     setFormError(validationResult === true ? "" : validationResult);
        // }
    };

    const apiCallingFunction = async (shouldCloseModal) => {
        try {
            let object = {
                ...formValue,
                firm_id: formValue?.firm_id?.value ? formValue?.firm_id?.value : '',
                gst_treatment_id: formValue?.gst_treatment_id?.value,
                gst_no: (formValue?.gst_treatment_id?.value === 2 || formValue?.gst_treatment_id?.value === 3) ? formValue.gst_no : '',
                gst_state: {
                    value: formValue?.gst_state?.value,
                    label: formValue?.gst_state?.label,
                },
                alt_contact_no: formValue?.alt_contact_no || '',
                contact_no: formValue?.contact_no || '',
                permission_at_supplier: {
                    supplier_freight: supplierFreight
                }
            };
            delete object.city.lat;
            delete object.city.long;
            delete object.state.lat;
            delete object.state.long;
            const res = await createBranch(object);
            if (res?.responseCode === 200) {
                setFormValue(formObj);
                setLoading(false);
                if (isEwayBillTrue) {
                    isPreviousModal(true);
                    // withoutFirstModalDirectLrOpen(...res?.data?.consignor);
                    showingPrefield(true);
                }
                if (shouldCloseModal) {
                    onClose();
                } else {
                    setActiveTab(1); // Reset tab to the first tab
                }
                if (res?.responseMessage) {
                    toast.success(`${res?.responseMessage}`);
                }
            } else {
                setLoading(false);
                if (res?.responseMessage) {
                    toast.error(`${res?.responseMessage}`);
                }
            }
        } catch (error) {
            setLoading(false);
            toast.error('Error !!');
        } finally {
            setIsButtonDisabled(false);
        }
    };

    const handleClick = async (e) => {
        e.preventDefault();
        const validationResult = await utils.checkFormError(formValue, errorSchema.createBranch);

        if (activeTab === 3) {
            if (utils.isObjectKeyEmpty(validationResult)) {
                setLoading(true);
                await apiCallingFunction(true); // Pass true to close the modal
                setFormError("");
            } else {
                setFormError(validationResult);
                setLoading(false);
            }
        } else {
            if (utils.isObjectKeyEmpty(validationResult)) {
                setActiveTab(activeTab + 1);
                setFormError("");
            } else {
                setFormError(validationResult);
            }
        }
    };

    const handleResetFormAndSubmit = async (e) => {
        e.preventDefault();
        setIsButtonDisabled(true); // Disable the button immediately
        const validationResult = await utils.checkFormError(formValue, errorSchema.createBranch);
        if (activeTab === 3) {
            if (utils.isObjectKeyEmpty(validationResult)) {
                setLoading(true);
                await apiCallingFunction(false); // Pass false to keep the modal open and reset the form
                setFormValue((s) => ({
                    ...s,
                    company_id: StorageService.getCompanyId(),
                    branch: '',
                    contact_no: '',
                    branch_code: '',
                    address_line1: '',
                    fssai_licence: '',
                    terms_conditions: '',
                    state: {},
                    city: {},
                    pincode: '',
                    email_id: '',
                    alt_contact_no: '',
                    remarks: '',
                    lr_bilty_format: '',
                    gst_state: states[0],
                    gst_treatment_id: masterData?.gst_type_list.map((el) => ({
                        label: el?.name,
                        value: el?.id,
                    }))[0],
                }));
                setSupplierFreigt(supplier_freight)
                setFormError("");
            } else {
                setFormError(validationResult);
                setLoading(false);
                setIsButtonDisabled(false); // Re-enable the button if validation fails
            }
        } else {
            if (utils.isObjectKeyEmpty(validationResult)) {
                setActiveTab(activeTab + 1);
                setFormError("");
                setIsButtonDisabled(false); // Re-enable the button if validation fails
            } else {
                setFormError(validationResult);
            }
        }
    };

    const handleClickUpdateBranch = async (e) => {
        e.preventDefault();
        const validationResult = await utils.checkFormError(formValue, errorSchema.createBranch);
        if (activeTab === 3) {
            if (utils.isObjectKeyEmpty(validationResult)) {
                setLoading(true);
                await updateApiCallingFunction();
                setFormError("");
            } else {
                setFormError(validationResult);
                setLoading(false);
            }
        } else {
            if (utils.isObjectKeyEmpty(validationResult)) {
                setActiveTab(activeTab + 1);
                setFormError("");
            } else {
                setFormError(validationResult);
            }
        }
    };


    const onhandleSelect = async (item, name) => {
        const stateObj = { ...formValue, [name]: item };
        setFormValue(stateObj);

        if (!utils.isObjectKeyEmpty(formError)) {
            const validationResult = await utils.checkFormError(stateObj, errorSchema.createBranch);
            setFormError(validationResult === true ? "" : validationResult);
        }
    };

    const changeActiveTab = async (event, value) => {
        event.preventDefault();
        if (value > activeTab) {
            const validationResult = await utils.checkFormError(formValue, errorSchema.createBranch);
            if (validationResult === true) {
                setActiveTab(value);
            } else {
                setFormError(validationResult);
            }
        } else {
            setActiveTab(value);
        }
    };

    const getStatesByApi = async (countryCode, stateCode) => {
        try {
            let data = {
                countryCode: countryCode ? countryCode : "IN",
                stateCode: stateCode ? stateCode : "",
            };
            let response = await getStatesData(data);
            if (response?.responseCode === 200) {
                if (countryCode && stateCode) {
                    setStateValue(response?.data[0]);
                    return response?.data[0];
                } else {
                    const optionsState = response?.data?.map((d) => {
                        return {
                            ...d,
                            label: d?.name,
                            value: d?.name
                        };
                    });

                    StorageService.setStates(JSON.stringify([...optionsState]))
                    setStates([...optionsState]);
                }
            } else {
                if (response) {
                    toast.error(response?.responseMessage)
                }
            }
        } catch (error) {
            toast.error("An unexpected error occurred. Please try again.");
        }
    };

    const handleCityChange = (data) => {
        handleOnChange("city", {
            label: data?.label,
            value: data?.name,
            lat: String(data?.latitude),
            long: String(data?.longitude)
        });

        getStatesByApi(data?.countryCode, data?.stateCode);

        // const stateDetails = State.getStateByCodeAndCountry(
        //     data?.stateCode,
        //     data?.countryCode
        // );
        // if (stateDetails?.name && stateDetails?.isoCode) {
        //     setStateValue(stateDetails);
        // }
    };

    useEffect(() => {
        if (stateValue?.name) {
            handleOnChange("state", {
                label: stateValue?.name, value: stateValue?.name, lat: String(stateValue?.latitude),
                long: String(stateValue?.longitude)
            })
        }
    }, [stateValue]);

    const updateApiCallingFunction = async () => {
        try {
            let object = {
                ...formValue,
                firm_id: formValue?.firm_id?.value ? formValue?.firm_id?.value : '',
                branch_id: isOpen?._id,
                gst_treatment_id: formValue?.gst_treatment_id?.value,
                gst_no: (formValue?.gst_treatment_id?.value === 2 || formValue?.gst_treatment_id?.value === 3) ? formValue.gst_no : '',
                gst_state: {
                    value: formValue?.gst_state?.value,
                    label: formValue?.gst_state?.label,
                },
                alt_contact_no: formValue?.alt_contact_no || '',
                contact_no: formValue?.contact_no || '',
                pincode: formValue?.pincode || '',
                permission_at_supplier: {
                    supplier_freight: supplierFreight
                }
            };
            // Remove redundant _id if branch_id exists
            if (object.branch_id) {
                delete object._id;
                delete object.gst_type;
                delete object.created_by;
                delete object.user_count;
                delete object.active;
                delete object.is_deleted;
                delete object.createdAt;
                delete object.updatedAt;
                delete object.pan_no;
                delete object.sim_based_tracking;
            }
            const res = await updateBranch(object);
            if (res?.responseCode === 200) {
                setFormValue(formObj);
                toast.success('Branch Updated Successfully');
                setLoading(false);
                if (isEwayBillTrue) {
                    isPreviousModal(true);
                    // withoutFirstModalDirectLrOpen(...res?.data?.consignor);
                    showingPrefield(true);
                }
                onClose();
            } else {
                if (res?.responseMessage) {
                    toast.error(`${res?.responseMessage}`);
                }
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
        }
    };


    const maxLengthCheck = (object) => {
        if (object.target.value.length > object.target.maxLength) {
            object.target.value = object.target.value.slice(0, object.target.maxLength)
        }
    }


    const addNewItemHandler = (e) => {

        setOpenLoction(true)
    }


    const callBackDataMaps = async (data) => {
        handleCityChange(data, "city")
        fetchFromCity()

    }

    let gmapLocates = {
        isOpen: openLoction,
        closeModal: (e) => setOpenLoction(false),
        modalMainClass: "_dashCommon_Modal _mdModalLoction",
        modalTitle: 'Add Location',
        submitTitle: 'Add Location',
        callBackDataMap: callBackDataMaps
    };

    const compName = useMemo(() => {
        if (!isOpen?._id) {
            let companyDetails = userData?.user_detail?.company_list?.find((item) => item?.company_id?._id === userData?.select_company_id)?.company_id;
            setFormValue((s) => ({
                ...s,
                display_name: companyDetails?.company
            }))
        }
    }, [userData])

    const getDataFirmList = async () => {
        try {
            let object = {
                company_id: StorageService.getCompanyId(),
            }
            const res = await getUserFirm(object);
            if (res?.responseCode == 200) {
                let apiData = res?.data?.firm_list?.map((el) => {
                    return {
                        label: el?.firm_id?.firm,
                        value: el?.firm_id?._id,
                    }
                })
                setFirmDataList(apiData);
                if (!isOpen?._id) {
                    if (apiData?.length === 1) {
                        setFormValue((s) => ({
                            ...s,
                            firm_id: apiData[0]
                        }))
                    } else {
                        setFormValue((s) => ({
                            ...s,
                            firm_id: {}
                        }))
                    }
                }
            }
        } catch (error) {
        }
    }

    useEffect(() => {
        getDataFirmList();
        getStatesByApi();
    }, [])

    useEffect(() => {
        if (firmId?._id) {
            setFormValue((s) => ({
                ...s,
                firm_id: { label: firmId?.firm, value: firmId?._id }
            }))
        } else if (firmDataList?.length > 0 && !isOpen?._id) {
            let findObject = firmDataList?.find((el) => el?.value === StorageService.getFirmId());
            setFormValue((s) => ({
                ...s,
                firm_id: findObject?.value ? findObject : {}
            }))
        }
    }, [StorageService.getFirmId(), firmDataList, isOpen])

    const youtubeProps = {
        isOpen: youtubeVideos,
        closeModal: () => setYoutubeVideos((s) => ({ ...s, moduleName: '', moduleAction: false })),
        headerPart: false,
        modalTitle: `Add Branch`,
        submitTitle: `Add Branch`,
        modalMainClass: "_mdModal",
        videosModuleName: constant.Key.branch
    }

    const handleGstDetailsInformation = async (gst_data) => {
        setGstInformationLoading(true);
        try {
            let object = {
                gstin: gst_data,
            }
            const res = await globleGstInformation(object);
            if (res?.responseCode == 200) {
                const resultData = res?.data?.response[0]?.response;
                setShowSelectListModal(resultData);
                setGstInformationLoading(false);
            } else {
                setGstInformationLoading(false);
            }
        } catch (error) {
            setGstInformationLoading(false);
        }
    }

    const handleFetch = (event) => {
        event.preventDefault();
        if (formValue?.gst_no?.length === 15 && !gstInformationLoading) {
            handleGstDetailsInformation(formValue?.gst_no)
        }
    }

    const onUpdateHandler = (event) => {
        event.preventDefault();
        setFormValue((s) => ({
            ...s,
            branch: showSelectListModal?.tradeName || showSelectListModal?.legalNameOfBusiness,
            address_line1: `${showSelectListModal?.principalPlaceOfBusinessFields?.principalPlaceOfBusinessAddress?.location} ${showSelectListModal?.principalPlaceOfBusinessFields?.principalPlaceOfBusinessAddress?.streetName || ''}, ${showSelectListModal?.principalPlaceOfBusinessFields?.principalPlaceOfBusinessAddress?.buildingName}, ${showSelectListModal?.principalPlaceOfBusinessFields?.principalPlaceOfBusinessAddress?.districtName}, ${showSelectListModal?.principalPlaceOfBusinessFields?.principalPlaceOfBusinessAddress?.pincode}`,
            state: showSelectListModal?.principalPlaceOfBusinessFields?.principalPlaceOfBusinessAddress?.stateName ? { label: showSelectListModal?.principalPlaceOfBusinessFields?.principalPlaceOfBusinessAddress?.stateName, value: showSelectListModal?.principalPlaceOfBusinessFields?.principalPlaceOfBusinessAddress?.stateName } : {},
            city: showSelectListModal?.principalPlaceOfBusinessFields?.principalPlaceOfBusinessAddress?.districtName ? { label: showSelectListModal?.principalPlaceOfBusinessFields?.principalPlaceOfBusinessAddress?.districtName, value: showSelectListModal?.principalPlaceOfBusinessFields?.principalPlaceOfBusinessAddress?.districtName } : {},
            pincode: showSelectListModal?.principalPlaceOfBusinessFields?.principalPlaceOfBusinessAddress?.pincode,
            gst_treatment_id: {
                label: "Registered Regular",
                value: 2
            },
            gst_no: showSelectListModal?.gstIdentificationNumber,
        }))
        setShowSelectListModal(false);
        setIsActionCreate(false);
    }

    let updateListProps = {
        isOpen: showSelectListModal,
        closeModal: (e) => setShowSelectListModal(false),
        onSubmit: (e) => setShowSelectListModal(false),
        modalMainClass: " _dashCommon_Modal  _mdModal",
        headerPart: true,
        floatCrossBtn: true,
        modalTitle: "Update By",
        footerPart: true,
        hideFooterSumbmitBtn: true,
        hideCompletelyFoolter: true,
        onUpdate: (e) => onUpdateHandler(e),
        onContinue: (e) => setShowSelectListModal(false),
    };

    return (
        <React.Fragment>
            <div className={formValue?.firm_id?.label ? `offcanvas-header offcan_header` : `offcanvas-header`}>
                {formValue?.firm_id?.label ?
                    <div>
                        <h5 className="offcanvas-title">{isOpen?._id ? 'Update Branch' : 'Add Branch'}</h5>
                        <p className='offcanvas_heading_head'>
                            <img src={FirmImg} className='firm_icon_img' /> {" "}
                            {formValue?.firm_id?.label ? formValue?.firm_id?.label : <Link to='/setting/firm'> Create Firm </Link>}
                        </p>
                    </div>
                    :
                    <h5 className="offcanvas-title">{isOpen?._id ? 'Update Branch' : 'Add Branch'}</h5>
                }

                <div className="flxs_lr_cls">
                    {!isOpen?._id && (
                        <div className="youtube_Icon" onClick={(e) => setYoutubeVideos((s) => ({ ...s, moduleName: 'branch_creation', moduleAction: true }))}>
                            <button><FaYoutube size={36} /></button>
                        </div>
                    )}
                    <CrossButton type="button" className="_switchBtn  __animEffect_btn" style={{ marginLeft: 'auto' }} onClick={() => onClose(!isOpen)}>
                        <svg className="cross" xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
                            <path
                                d="M12.5321 0.477671C12.4422 0.387555 12.3353 0.316061 12.2177 0.267281C12.1001 0.2185 11.9741 0.193391 11.8468 0.193391C11.7195 0.193391 11.5934 0.2185 11.4758 0.267281C11.3582 0.316061 11.2514 0.387555 11.1615 0.477671L6.40798 5.22143L1.6545 0.46795C1.56451 0.377952 1.45766 0.306563 1.34008 0.257857C1.22249 0.20915 1.09646 0.184082 0.969185 0.184082C0.84191 0.184082 0.715881 0.20915 0.598294 0.257857C0.480707 0.306563 0.373865 0.377952 0.283868 0.46795C0.19387 0.557947 0.122481 0.664789 0.0737746 0.782376C0.0250685 0.899963 -9.48274e-10 1.02599 0 1.15327C9.48275e-10 1.28054 0.0250684 1.40657 0.0737746 1.52416C0.122481 1.64175 0.19387 1.74859 0.283868 1.83858L5.03735 6.59206L0.283868 11.3455C0.19387 11.4355 0.122481 11.5424 0.0737746 11.66C0.0250685 11.7776 0 11.9036 0 12.0309C0 12.1581 0.0250685 12.2842 0.0737746 12.4017C0.122481 12.5193 0.19387 12.6262 0.283868 12.7162C0.373865 12.8062 0.480707 12.8776 0.598294 12.9263C0.715881 12.975 0.84191 13 0.969185 13C1.09646 13 1.22249 12.975 1.34008 12.9263C1.45766 12.8776 1.56451 12.8062 1.6545 12.7162L6.40798 7.9627L11.1615 12.7162C11.2515 12.8062 11.3583 12.8776 11.4759 12.9263C11.5935 12.975 11.7195 13 11.8468 13C11.974 13 12.1001 12.975 12.2177 12.9263C12.3353 12.8776 12.4421 12.8062 12.5321 12.7162C12.6221 12.6262 12.6935 12.5193 12.7422 12.4017C12.7909 12.2842 12.816 12.1581 12.816 12.0309C12.816 11.9036 12.7909 11.7776 12.7422 11.66C12.6935 11.5424 12.6221 11.4355 12.5321 11.3455L7.77861 6.59206L12.5321 1.83858C12.9015 1.46919 12.9015 0.847062 12.5321 0.477671Z"
                                fill="black" />
                        </svg>
                    </CrossButton>
                </div>
            </div>

            <div className="offcanvas-body">
                <div className='pr_procssBx'>
                    <div className='pr_procssBx_grid'>

                        {!isOpen?._id && firmDataList?.length > 1 && <div className='singleDiv'>
                            <CustomSelect
                                options={firmDataList}
                                label="Select Firm"
                                placeholder="Select Firm"
                                name="firm_id"
                                value={formValue?.firm_id}
                                error={formError["firm_id.label"]}
                                onSelect={(data) => onhandleSelect(data, 'firm_id')}
                                disabled={hideAddNewOption ? false : (formValue?.firm_id?.value ? true : false)}
                            />
                        </div>}

                        <div className='singleDiv'>
                            <CommonInput
                                type="text"
                                placeholder="Branch Name"
                                label="Branch Name *"
                                name='branch'
                                value={formValue.branch}
                                focus={!!(typeof formError === "object" && formError?.branch)}
                                error={!!(typeof formError === "object") ? formError?.branch : ""}
                                maxLength="40"
                                onInput={utils.maxLengthCheck}
                                onChange={(e) => utils.handleNameInputChange(e, handleOnChange)}
                            // onChange={({ target: { name, value } }) =>
                            //     handleOnChange(name, value)
                            // }
                            />
                        </div>

                        <div className='singleDiv'>
                            <CommonInput
                                type="text"
                                placeholder="Display Name"
                                label="Display Name"
                                name='display_name'
                                value={formValue.display_name}
                                maxLength="40"
                                onInput={utils.maxLengthCheck}
                                onChange={(e) => utils.handleNameInputChange(e, handleOnChange)}
                            />
                        </div>

                        <div className='singleDiv'>
                            <CommonInput
                                type="text"
                                placeholder="Branch Code"
                                label="Branch Code"
                                name='branch_code'
                                maxLength="30"
                                onInput={utils.maxLengthCheck}
                                value={formValue.branch_code}
                                focus={!!(typeof formError === "object" && formError?.branch_code)}
                                error={!!(typeof formError === "object") ? formError?.branch_code : ""}
                                onChange={({ target: { name, value } }) =>
                                    handleOnChange(name, value)
                                }
                            />
                        </div>

                        <div className='singleDiv'>
                            <CommonInput
                                type="text"
                                placeholder="Mobile Number"
                                label='Mobile Number'
                                name='contact_no'
                                maxLength="16"
                                value={formValue.contact_no}
                                focus={!!(typeof formError === "object" && formError?.contact_no)}
                                error={!!(typeof formError === "object") ? formError?.contact_no : ""}
                                onInput={utils.maxLengthCheck}
                                onFocus={(e) => e.target.addEventListener("wheel", function (e) { e.preventDefault() }, { passive: false })}
                                onChange={(e) => utils.handleMobileInputChange(e, handleOnChange)}
                            // onChange={({ target: { name, value } }) =>
                            //     handleOnChange(name, value)
                            // }
                            />
                        </div>

                    </div>

                    {/*
                     <div className='checkBx_lv mt-2'>
                        {
                            constant.Receive_Pay?.map((el, ind) => {
                                return (
                                    <React.Fragment key={ind}>
                                        <input
                                            className="form-check-input"
                                            id={+ind + "pay_type" + el?.value}
                                            type="radio"
                                            name="pay_type"
                                            checked={formValue?.pay_type === el?.value}
                                            value={formValue?.pay_type ? formValue?.pay_type : ""}
                                            onChange={({ target: { name, value } }) =>
                                                handleOnChange(name, el?.value)
                                            }
                                        />
                                        <label htmlFor={+ind + "pay_type" + el.value} className="form-check-label" >
                                            {el.label}
                                        </label> &nbsp;
                                    </React.Fragment>
                                )
                            })
                        }
                    </div> 
                    */}
                </div>

                <div className='addPr_flBx __newTabs_bx'>
                    <ul className="nav nav-tabs cstNew_tabs" id="addParty" role="tablist">
                        {constant.addBranchTabs?.map((item, indx) => (
                            <li
                                className="nav-item"
                                role="presentation"
                                key={indx + item?.value}
                            >
                                <button
                                    className={
                                        "nav-link " + (activeTab === item?.id ? "active" : "")
                                    }
                                    type="button"
                                    aria-selected={activeTab === item?.id}
                                    onClick={(e, val) => changeActiveTab(e, item.id)}
                                >
                                    {item?.title}
                                </button>
                            </li>
                        ))}
                    </ul>

                    {activeTab === 1 && (
                        <div className='pr_procssBx' id="addPartyContent">
                            <div className='pr_procssBx_grid'>

                                <div className='singleDiv'>
                                    <div className="h4Head">Add Address</div>
                                </div>

                                <div className='singleDiv'>
                                    <CommonInput
                                        type="text"
                                        placeholder="Address Line 1"
                                        label="Address Line 1"
                                        name='address_line1'
                                        value={formValue.address_line1}
                                        focus={!!(typeof formError === "object" && formError?.address_line1)}
                                        error={!!(typeof formError === "object") ? formError?.address_line1 : ""}
                                        onChange={({ target: { name, value } }) =>
                                            handleOnChange(name, value)
                                        }
                                    />
                                </div>

                                <div className='singleDiv'>
                                    {/* <CustomSelect
                                        options={cities}
                                        optionShowCityState={true}
                                        onSelect={(data) => handleCityChange(data, 'city')}
                                        value={formValue?.city}
                                        placeholder="Select a city"
                                        error={formError["city.label"]}
                                        label="City"
                                    /> */}
                                    <CityDropdownForTrip
                                        key={`fromLoction`}
                                        label="City "
                                        placeholder="Select a city"
                                        fetchData={fetchFromCity}
                                        isAddButton={true}
                                        addButtonAction={(e) => addNewItemHandler(e)}
                                        pageSize={20}
                                        onChange={(data) => handleCityChange(data, "city")}

                                        selectedItem={formValue?.city}
                                        error={!!formError["city.label"]}
                                        errorMessage={
                                            formError["city.label"]
                                        }
                                        withState={false}
                                    />
                                </div>

                                <div className='halfDiv'>
                                    <CommonInput
                                        type="text"
                                        placeholder="State"
                                        label="State"
                                        name='state'
                                        disabled={true}
                                        value={formValue?.state?.label}
                                        focus={!!(typeof formError === "object" && formError?.state)}
                                        error={!!(typeof formError === "object") ? formError?.state : ""}
                                        onChange={({ target: { name, value } }) =>
                                            handleOnChange(name, value)
                                        }
                                    />
                                </div>

                                <div className='halfDiv'>
                                    <CommonInput
                                        type="text"
                                        placeholder="PIN Code"
                                        label="PIN Code"
                                        name="pincode"
                                        maxLength={6}

                                        value={formValue.pincode}
                                        focus={!!(typeof formError === "object" && formError?.pincode)}
                                        error={!!(typeof formError === "object") ? formError?.pincode : ""}
                                        onChange={({ target: { name, value } }) => {
                                            if (/^\d*$/.test(value)) {
                                                handleOnChange(name, value);
                                            }
                                        }}
                                    />
                                </div>

                                <div className='singleDiv'>
                                    <div className="h4Head">Other Contact</div>
                                </div>

                                <div className='singleDiv'>
                                    <CommonInput
                                        type="text"
                                        placeholder="Alternate Number"
                                        label="Alternate Number"
                                        name='alt_contact_no'
                                        maxLength="16"
                                        value={formValue?.alt_contact_no || ''}
                                        focus={!!(typeof formError === "object" && formError?.alt_contact_no)}
                                        error={!!(typeof formError === "object") ? formError?.alt_contact_no : ""}
                                        onInput={utils.maxLengthCheck}
                                        onFocus={(e) => e.target.addEventListener("wheel", function (e) { e.preventDefault() }, { passive: false })}
                                        onChange={(e) => utils.handleMobileInputChange(e, handleOnChange)}
                                    // onChange={({ target: { name, value } }) =>
                                    //     handleOnChange(name, value)
                                    // }
                                    />
                                </div>

                                <div className='singleDiv'>
                                    <CommonInput
                                        type="Email"
                                        placeholder="Email ID"
                                        label='Email ID'
                                        name='email_id'
                                        maxLength="50"
                                        onInput={utils.maxLengthCheck}
                                        value={formValue.email_id}
                                        focus={!!(typeof formError === "object" && formError?.email_id)}
                                        error={!!(typeof formError === "object") ? formError?.email_id : ""}
                                        onChange={({ target: { name, value } }) =>
                                            handleOnChange(name, value)
                                        }
                                    />
                                </div>

                                <div className='singleDiv'>
                                    <CommonInput
                                        type="text"
                                        placeholder="Remark"
                                        label='Remark'
                                        name='remarks'
                                        value={formValue.remarks}
                                        focus={!!(typeof formError === "object" && formError?.remarks)}
                                        error={!!(typeof formError === "object") ? formError?.remarks : ""}
                                        onChange={({ target: { name, value } }) =>
                                            handleOnChange(name, value)
                                        }
                                    />
                                </div>
                            </div>
                        </div>
                    )}

                    {activeTab === 2 && (
                        <div className='pr_procssBx' id="addPartyContent">
                            <div className='pr_procssBx_grid'>
                                <div className='singleDiv'>
                                    <CustomSelect
                                        options={masterData?.gst_type_list?.map((el) => {
                                            return {
                                                label: el?.name,
                                                value: el?.id
                                            }
                                        })}
                                        name="gst_treatment_id"
                                        flotingLabel="GST Type"
                                        value={formValue?.gst_treatment_id}
                                        focus={!!(typeof formError === "object" && formError?.gst_treatment_id)}
                                        error={!!(typeof formError === "object") ? formError?.gst_treatment_id : ""}
                                        onSelect={(data) => onhandleSelect(data, 'gst_treatment_id')}
                                        placeholder="Select GST Type"
                                    />
                                </div>


                                {
                                    (formValue?.gst_treatment_id?.value == '2' || formValue?.gst_treatment_id?.value == '3') && (
                                        <div className='singleDiv _relatePos'>
                                            <CommonInput
                                                type="text"
                                                placeholder="GST Number e.g. 09AAACH7409R1RR"
                                                label='GST Number'
                                                name='gst_no'
                                                value={formValue.gst_no}
                                                onChange={({ target: { name, value } }) =>
                                                    handleOnChange(name, value.toUpperCase())
                                                }
                                                focus={!!(typeof formError === "object" && formError?.gst_no)}
                                                error={!!(typeof formError === "object") ? formError?.gst_no : ""}
                                                maxLength="15"
                                            />
                                            <span className='_weightSpan _avPointer' onClick={(e) => handleFetch(e)}> Fetch </span>
                                        </div>
                                    )
                                }

                                <div className='singleDiv'>
                                    <CustomSelect
                                        // options={states?.map((el) => {
                                        //     return {
                                        //         label: el?.name,
                                        //         value: el?.name
                                        //     }
                                        // })}
                                        options={states}
                                        name="gst_state"
                                        flotingLabel="GST State"
                                        value={formValue?.gst_state}
                                        focus={!!(typeof formError === "object" && formError?.gst_state)}
                                        error={!!(typeof formError === "object") ? formError?.gst_state : ""}
                                        onSelect={(data) => onhandleSelect(data, 'gst_state')}
                                        placeholder="Select GST State"
                                    />
                                </div>

                            </div>
                        </div>
                    )}

                    {activeTab === 3 && (
                        <div className='pr_procssBx' id="addPartyContent">
                            <div className='pr_procssBx_grid'>


                                <div className='singleDiv'>
                                    <CommonInput
                                        type="text"
                                        placeholder="Fssai Licence"
                                        label="Fssai Licence"
                                        name='fssai_licence'
                                        value={formValue.fssai_licence}
                                        maxLength="14"
                                        onInput={utils.maxLengthCheck}
                                        focus={!!(typeof formError === "object" && formError?.fssai_licence)}
                                        error={!!(typeof formError === "object") ? formError?.fssai_licence : ""}
                                        onChange={(e) => utils.withoutDotLettersSpaceSpecialCharacters(e, handleOnChange)}
                                    // onChange={({ target: { name, value } }) =>
                                    //     handleOnChange(name, value)
                                    // }
                                    />
                                </div>

                                <div className='singleDiv'>
                                    <CommonTextarea
                                        type="text"
                                        rows={5}
                                        placeholder='Terms and Conditions'
                                        label='Terms and Conditions'
                                        name='terms_conditions'
                                        maxLength="500"
                                        onInput={utils.maxLengthCheck}
                                        value={formValue.terms_conditions}
                                        focus={!!(typeof formError === "object" && formError?.terms_conditions)}
                                        error={!!(typeof formError === "object") ? formError?.terms_conditions : ""}
                                        onChange={({ target: { name, value } }) =>
                                            handleOnChange(name, value)
                                        }
                                    />
                                </div>

                                <div className='singleDiv'>
                                    <CustomSelect
                                        options={masterData?.lr_bilty_format_list?.map((el) => {
                                            return {
                                                label: el?.name,
                                                value: el?.id
                                            }
                                        })}
                                        name="lr_bilty_format_list"
                                        flotingLabel="LR Bilty Format"
                                        value={builtyFormat?.lr_bilty_format}
                                        focus={!!(typeof formError === "object" && formError?.lr_bilty_format)}
                                        error={!!(typeof formError === "object") ? formError?.lr_bilty_format : ""}
                                        onSelect={(data) => onhandleSelectBuilty(data, 'lr_bilty_format')}
                                        placeholder="Select LR Bilty Format"
                                    />
                                </div>
                                <div className='singleDiv'>

                                    <div className='_permisionBx_ls p-1'>
                                        <div className='_headPermission fw-400'> Supplier Freight Chargeable On Dispatch </div>

                                        <div className='_brxFlex gap-x-4'>
                                            <div className='_dLass min-w-auto'>
                                                <div>
                                                    <CommonCheckbox
                                                        type="checkbox"
                                                        name="view"
                                                        id="pod_number_view"
                                                        isChecked={supplierFreight?.view}

                                                        handleClick={({ target: { name, checked } }) => {

                                                            handleOnChangeCheck("view", checked ? 1 : 0)
                                                        }

                                                        }
                                                    />
                                                </div>
                                            </div>
                                            <div className='_dLass min-w-auto'>
                                                <div>
                                                    <CommonCheckbox
                                                        type="checkbox"
                                                        name="mandatory"
                                                        id="pod_number_mandatory"
                                                        isChecked={supplierFreight?.mandatory}
                                                        disabled={!supplierFreight?.view}
                                                        handleClick={({ target: { name, checked } }) => {

                                                            handleOnChangeCheck("mandatory", checked ? 1 : 0)
                                                        }

                                                        }
                                                    />
                                                </div>
                                            </div>

                                        </div>

                                    </div>
                                </div>

                            </div>
                        </div>
                    )}
                </div>

            </div>

            <div className='offcanvas-footer'>
                {
                    (activeTab === 1 || activeTab === 2) && (
                        <AddButton
                            onClick={handleClick}
                            disabled={!formValue?.branch}
                            name='Continue'
                        />
                    )
                }
                {
                    activeTab === 3 && !isOpen?._id && (
                        <React.Fragment>
                            <AddButton
                                onClick={handleClick}
                                disabled={loading}
                                name='Add Branch'
                            />
                            <button
                                className={isButtonDisabled ? '_addNewComm_btn_disabled' : '_addNewComm_btn'}
                                onClick={handleResetFormAndSubmit}
                                disabled={isButtonDisabled || loading}
                            >
                                Add & New
                            </button>
                        </React.Fragment>
                    )
                }
                {
                    (activeTab === 3 && isOpen?._id) && (
                        <AddButton
                            onClick={handleClickUpdateBranch}
                            disabled={loading}
                            name='Update Branch'
                        />
                    )
                }
            </div>

            {openLoction && <AddLocationModal {...gmapLocates} />}

            {
                (youtubeVideos?.moduleName === 'branch_creation' && youtubeVideos?.moduleAction === true)
                && (
                    <YoutubeModal {...youtubeProps} />
                )
            }

            {showSelectListModal && <GstDetailModal {...updateListProps} />}

        </React.Fragment>
    )
}

export default AddEditBranch
